import { useState } from 'react';
import styles from './ReassignToCurrentUserModal.module.scss';
import { Button, Icon, Modal, Text } from 'components';
import { appActions } from 'store/app/slice';
import { selectCurrentPatientCase } from 'store/patients/selectors';
import { patientsActions } from 'store/patients/slice';
import { useDispatch, useSelector } from 'store/utils';
import { dateNowUTC } from 'utils';

export const ReassignToCurrentUserModal = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const currentPatientCase = useSelector(selectCurrentPatientCase);

  const onClose = () => {
    dispatch(appActions.setIsModalOpened({ name: 'reassignUser', isOpened: false }));
  };

  const onSubmit = async () => {
    if (!currentPatientCase?.id || isLoading) return;

    try {
      setIsLoading(true);
      const timestamp = dateNowUTC();
      dispatch(patientsActions.setPatientPageTimestamp(timestamp));

      await dispatch(
        patientsActions.assignPatientCaseToDoctor({
          assignCaseToDoctorData: {
            checkFrom: timestamp,
          },
          patientCaseId: currentPatientCase.id,
        }),
      ).unwrap();

      onClose();
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal title={'Assign doctor'} onClose={onClose}>
      <div>
        <div className={styles.container}>
          <Icon name="X" className={styles.icon} />
          <Text className={styles.title} type="body-big">
            Patient case is already assigned
          </Text>
          <div className={styles.descriptionText}>
            <Text type="body2" className={styles.helpMessage}>
              Another doctor at that time has assigned the case to themselves. Do you still want to assign patient to
              you anyway?
            </Text>
          </div>
        </div>
        <div className={styles.buttonRow}>
          <Button isLink onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onSubmit}>Assign to me</Button>
        </div>
      </div>
    </Modal>
  );
};
